import { UserUpdateStatusResponse } from "../../proto/UserUpdateStatus_pb";
import store from "../../store";
import { updateUser } from "../../store/users/actions";
import BaseHandler from "../BaseHandler";
import { RegisteredUser } from "../../proto/Global_pb";
import { getStorage } from "../../libs/storage";
import { STORAGE_USER_ID } from "../../constants/localstorage";

export default class HandleUserUpdateStatusResponse extends BaseHandler<UserUpdateStatusResponse> {
  handle() {
    const userUpdateStatusResponse = this.response.toObject();
    if (userUpdateStatusResponse.userId === getStorage(STORAGE_USER_ID)) return;
    const status =
      userUpdateStatusResponse.status === 0
        ? {
            lastSeen: undefined,
            status: RegisteredUser.Status.ONLINE,
          }
        : {
            lastSeen: Math.floor(new Date().getTime() / 1000),
            status: RegisteredUser.Status.EXACTLY,
          };
    store.dispatch(
      updateUser({
        userId: userUpdateStatusResponse.userId,
        values: {
          ...status,
        },
      })
    );
  }
}
